import { Table, TableContainer, Tbody, Td, Tr } from '@apollo/orbit';
import classnames from 'classnames';
import React from 'react';

import { ShimmerLoading } from 'src/components/common/loading/ShimmerLoading';

export const ErrorBreakdownLoading = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <div className={classnames('chromatic-ignore mt-1', className)}>
      <TableContainer>
        <Table layout="fixed">
          <Tbody>
            {[0, 1].map((d) => (
              <Tr key={d}>
                <Td width="40%">
                  <ShimmerLoading className="my-2 mr-1 h-6" />
                </Td>
                <Td>
                  <ShimmerLoading className="my-2 mr-1 h-6" />
                </Td>
                <Td>
                  <ShimmerLoading className="my-2 h-6" />
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </div>
  );
};
